import { UserService } from './user.service';
import { Injectable } from '@angular/core';
import { Observable, from, Subscriber, Subject } from 'rxjs';
import { Role, User, LoginForm, NewUser, ForgotPassword } from './user.types';

@Injectable()
export class AuthService {
	private userObservable: Observable<User>;
	private userSubject = new Subject<User>();
	private isLoading: boolean;
	private user: User | null = null;

	constructor(private _us: UserService) {
		this.userObservable = Observable.create((subscriber: Subscriber<User>) => {
			this.userSubject.subscribe(subscriber);
			if (!this.isLoading) {
				this.userSubject.next(this.user);
			}
		});
		this.loadUser();
	}

	watchUser(): Observable<User> {
		return from(this.userObservable);
	}

	getUser(): User | null {
		return this.user;
	}

	isInRole(role: Role): boolean {
		if (!this.user) return false;

		return this.user.roles.some(x => x <= role);
	}

	login(loginForm: LoginForm): Promise<User> {
		return this._us.login(loginForm)
			.then(user => this.handleResponse(user));
	}

	register(newUser: NewUser): Promise<User> {
		return this._us.register(newUser)
			.then(user => this.handleResponse(user));
	}

	resetForgottenPassword(forgotPassword: ForgotPassword): Promise<User> {
		return this._us.resetForgottenPassword(forgotPassword)
			.then(user => this.handleResponse(user));
	}

	private loadUser() {
		this.isLoading = true;
		this._us.loadUser()
			.then(user => this.handleResponse(user))
			.catch(x => {
				this.isLoading = false;
				this.userSubject.next(this.user);
			});
	}

	private handleResponse(user: User): User {
		this.user = user;
		this.userSubject.next(this.user);
		this.isLoading = false;
		return this.user;
	}

	async logout(): Promise<any> {
		this.user = null;
		this.userSubject.next(this.user);
		await this._us.logout();
	}
}
